module.exports = ".div-scroll {\r\n  height: 80vh;\r\n}\r\n"